import { useState } from 'react';
const useCircuitType = () => {
  const [values, setValues] = useState(null);
  if (!values) {
    setValues([{
      value: 'training',
      label: 'Training'
    }, {
      value: 'warm_up',
      label: 'Warm up'
    }, {
      value: 'cooldown',
      label: 'Cool down'
    }]);
  }
  return values;
};
export default useCircuitType;